export default "__VITE_ASSET__B3k7PfJx__"